function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Card, Pill } from "../../components/analytics-kit";
import { getRepScorecard, getDealerScorecard } from "./sales-api";
import { usdK, pct0, Spark, elapsedLabel, targetWindowLabel } from "./exec-kit";
import { isInProgressRange } from "../stores/common";

/*
 * The one change to the existing detail pages (SALES_EXECUTIVE_VIEW.md §5.5,
 * mockup section F): a "Plan" card on Rep detail, Customer (dealer) detail and
 * Market detail fed by /v1/sales/scorecards/{kind}/{range}/{id}: target,
 * attainment, pace and the monthly sparkline against plan. Hidden when there is
 * no target for the scope, and silently absent while the scorecard rail is not
 * deployed (fail-soft).
 *
 * props: kind 'rep' | 'dealer' · id · range · comparison · span (grid columns)
 *        card: an already-loaded scorecard (the dealer page fetches it once for
 *        its Health block and hands it down; null = no scorecard)
 */
export default class PlanCard extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      card: undefined
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  componentDidUpdate(prev) {
    if (prev.kind !== this.props.kind || prev.id !== this.props.id || prev.range !== this.props.range) this.load();
  }
  async load() {
    if (this.props.card !== undefined) return;
    const {
      kind,
      id,
      range,
      comparison
    } = this.props;
    if (!id || !range) {
      this.setState({
        card: null
      });
      return;
    }
    try {
      const card = kind === "rep" ? await getRepScorecard(range, id, {
        comparison
      }) : await getDealerScorecard(range, id, {
        comparison
      });
      if (this._alive) this.setState({
        card: card || null
      });
    } catch (e) {
      if (this._alive) this.setState({
        card: null
      });
    }
  }
  render() {
    const card = this.props.card !== undefined ? this.props.card : this.state.card;
    const {
      range,
      span = 4
    } = this.props;
    if (!card || !card.target) return null;
    const inProgress = isInProgressRange(range);
    const plan = card.raw && Array.isArray(card.raw.plan) ? card.raw.plan.map(v => v && typeof v === "object" ? Number(v.plan || v.target || v.value) || 0 : Number(v) || 0) : card.raw && Array.isArray(card.raw.planSparkline) ? card.raw.planSparkline.map(Number) : null;
    const onPlan = card.pace != null ? card.pace >= 1 : card.attainment != null ? card.attainment >= 1 : null;
    const runRate = card.pace != null && card.target ? card.pace * card.target : null;
    return /*#__PURE__*/React.createElement(Card, {
      title: "Plan",
      hint: `${targetWindowLabel(range).toLowerCase()} · ${inProgress ? elapsedLabel(range) : "complete window"}`,
      span: span,
      right: onPlan != null ? /*#__PURE__*/React.createElement(Pill, {
        tone: onPlan ? "success" : card.pace != null && card.pace >= 0.9 ? "warning" : "danger"
      }, onPlan ? "On plan" : "Behind plan") : null
    }, /*#__PURE__*/React.createElement("div", {
      className: "sx-plancard"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, inProgress ? "Attainment · of plan" : "Attainment"), /*#__PURE__*/React.createElement("div", {
      className: "big"
    }, card.attainment != null ? pct0(card.attainment) : "—"), /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, usdK(card.revenue), " of ", usdK(card.target))), inProgress ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, "Pace to window end"), /*#__PURE__*/React.createElement("div", {
      className: `big ${card.pace != null ? card.pace >= 1 ? "up" : card.pace >= 0.9 ? "" : "down" : ""}`
    }, card.pace != null ? pct0(card.pace) : "—"), /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, runRate != null ? `run-rate ${usdK(runRate)} vs plan ${usdK(card.target)}` : "")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, "Target"), /*#__PURE__*/React.createElement("div", {
      className: "big"
    }, usdK(card.target)), /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, card.forecastNextQuarter ? `forecast next quarter ${usdK(card.forecastNextQuarter)}` : "")), card.sparkline.length > 1 ? /*#__PURE__*/React.createElement("div", {
      className: "wide"
    }, /*#__PURE__*/React.createElement(Spark, {
      values: card.sparkline,
      plan: plan,
      w: 520,
      h: 70
    }), /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, "Monthly revenue", plan ? " vs plan (dashed)" : "")) : null));
  }
}